import { Flex, Modal, Spin } from "antd";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "../modal/styles.css";
import Text from "../typography/text";
import TextInput from "../text-input";
import { LoadingOutlined } from "@ant-design/icons";
import CrossIcon from "../../icons/cross-icon";

const ModalView = ({
  isOpen,
  onClose,
  isLoading = false,
  children,
  // width = "1020px",
  maxWidth = "1125px",
  minWidth = "800px",
  setIsOpen,
  modalTitle,
  modalSubTitle,
  textInputComponent,
  footerButtonWrapper,
  parentClassname,
  additionalComponents,
  headerRightContent,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="custom-modal-backdrop"
      // onClick={onClose}
    >
      <div
        className={`custom-modal-content ${parentClassname}`}
        style={{ minWidth, maxWidth }}
        // onClick={(e) => e.stopPropagation()}
      >
        {isLoading && (
          <Flex align="center" gap="middle">
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 48,
                  }}
                  spin
                />
              }
              fullscreen
            />
          </Flex>
        )}
        <div className="modal-container">
          {modalTitle ? (
            <div className="modal-top">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Text variant="h1">{modalTitle}</Text>
                <div className="modal-top-right">
                  {headerRightContent}
                  <div onClick={onClose} style={{ cursor: "pointer" }}>
                    <CrossIcon className="modal-cross-icon" />
                  </div>
                </div>
              </div>
              {modalSubTitle ? (
                <Text variant="smallText" color="lightText">
                  {modalSubTitle}
                </Text>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
          <div>{textInputComponent}</div>
          {/* {additionalComponents ? <div>{additionalComponents}</div> : null} */}
          <div>{footerButtonWrapper}</div>
        </div>
      </div>
    </div>,
    document.body
  );

  // <Modal
  //   open={isOpen}
  //   centered={true}
  //   footer={false}
  //   style={{
  //     maxWidth: "1060px",
  //     minWidth: "800px"
  //   }}
  //   onCancel={() => setIsOpen(!isOpen)}
  // >
  // <div className="modal-top">
  //   <Text variant="h1">{modalTitle}</Text>
  //   <Text variant="smallText" color="lightText">
  //     {modalSubTitle}
  //   </Text>
  // </div>
  // <div>{textInputComponent}</div>
  // <div>{footerButtonWrapper}</div>
  // </Modal>
};

export default ModalView;
